/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ChangelogPage } from '../model';
/**
 * ChangelogApi - axios parameter creator
 * @export
 */
export const ChangelogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get entity assumption changelog entries
         * @param {number} entityId 
         * @param {number} assumptionId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {boolean} [paged] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityAssumptionChangelog: async (entityId: number, assumptionId: number, page?: number, size?: number, paged?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('entityAssumptionChangelog', 'entityId', entityId)
            // verify required parameter 'assumptionId' is not null or undefined
            assertParamExists('entityAssumptionChangelog', 'assumptionId', assumptionId)
            const localVarPath = `/navigator/entities/{entityId}/assumptions/{assumptionId}/changelog`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"assumptionId"}}`, encodeURIComponent(String(assumptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (paged !== undefined) {
                localVarQueryParameter['paged'] = paged;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChangelogApi - functional programming interface
 * @export
 */
export const ChangelogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChangelogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get entity assumption changelog entries
         * @param {number} entityId 
         * @param {number} assumptionId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {boolean} [paged] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entityAssumptionChangelog(entityId: number, assumptionId: number, page?: number, size?: number, paged?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChangelogPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entityAssumptionChangelog(entityId, assumptionId, page, size, paged, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ChangelogApi - factory interface
 * @export
 */
export const ChangelogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChangelogApiFp(configuration)
    return {
        /**
         * 
         * @summary Get entity assumption changelog entries
         * @param {number} entityId 
         * @param {number} assumptionId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {boolean} [paged] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entityAssumptionChangelog(entityId: number, assumptionId: number, page?: number, size?: number, paged?: boolean, options?: any): AxiosPromise<ChangelogPage> {
            return localVarFp.entityAssumptionChangelog(entityId, assumptionId, page, size, paged, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChangelogApi - object-oriented interface
 * @export
 * @class ChangelogApi
 * @extends {BaseAPI}
 */
export class ChangelogApi extends BaseAPI {
    /**
     * 
     * @summary Get entity assumption changelog entries
     * @param {number} entityId 
     * @param {number} assumptionId 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {boolean} [paged] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChangelogApi
     */
    public entityAssumptionChangelog(entityId: number, assumptionId: number, page?: number, size?: number, paged?: boolean, options?: any) {
        return ChangelogApiFp(this.configuration).entityAssumptionChangelog(entityId, assumptionId, page, size, paged, options).then((request) => request(this.axios, this.basePath));
    }
}
